import React from 'react';
import styles from './Applicators.module.scss'
// import ApplicatorsGrid from "../../../components/ApplicatorsGrid/ApplicatorsGrid";
import ApplicatorsTable from "../../../components/ApplicatorsTable/ApplicatorsTable";


const DistributorApplicators = () => {
    return (
        <div className={styles.container}>
            <div className={styles['box']}>
                <ApplicatorsTable />
                {/*<ApplicatorsGrid userType={3} />*/}
            </div>
        </div>
    )
}

export default DistributorApplicators;
